import { GeneralReportStore } from './../Stores/GeneralReportStore';

export class DrShotAnalysisReportStore extends GeneralReportStore {
  tilesToDisplay: Array<string> = [
    'Total',
    'SideTotal',
    'Carry',
    'Side',
    'BallSpeed',
    'LaunchDirection',
    'LaunchAngle',
    'Height',
    //,"DistanceToPin"
  ];
  siteName = '';
  siteShortName = '';
}
